// @flow
import FormGroup from './FormGroup';
import type { FormGroupProps } from './FormGroup';

export default FormGroup;
export type { FormGroupProps };
